export default __webpack_public_path__ + "static/media/elmojones.b12f7533.jpg";